import { Box, Grid, Paper, Stack, Typography } from '@mui/material';

import { useParams } from 'react-router-dom';
import AvatarStatusFavorite from './AvatarStatusFavorite';
import TalentProfileCompletionRate from './TalentProfileCompletionRate';
import { TalentBanner } from './TalentBanner';
import TalentBioCard from './TalentBioCard';
import TalentCertificatetList from './TalentCertificate/TalentCertificateForm';
import TalentContactsCard from './TalentContactsCard';
import TalentEducationList from './TalentEducation/TalentEducationForm';
import TalentExperienceList from './TalentExperience/TalentExperienceForm';
import LanguageForm from './TalentLanguageForm/LanguageForm';
import TalentPreferencesForm from './TalentPreference/TalentPreferenceForm';
import TalentProfileCard from './TalentProfileCard';
import TalentSalaryCard from './TalentSalaryCard';
import TalentSoftSkillsForm from './TalentSoftSkills/TalentSoftSkillsForm';
import { useTalentOperations } from '../context/TalentOperationsContext';
import { useGetTalent } from './useGetTalent';

const TalentPreview = () => {
    const { updateStatus } = useTalentOperations();
    // get talentId from route params or props react-router-dom.
    const { id: talentId } = useParams();

    const { talent, loading, error, refetch } = useGetTalent(talentId);

    // Show loading state
    if (loading) {
        return (
            <Box p={2} pt={0}>
                <Typography>Chargement des données du talent...</Typography>
            </Box>
        );
    }

    // Show error state
    if (error || !talent) {
        return (
            <Box p={2} pt={0}>
                <Typography color="error">
                    {error ? 'Erreur lors du chargement des données du talent' : 'Talent introuvable'}
                </Typography>
            </Box>
        );
    }

    return (
        <Paper sx={{ p: 2, pt: 0 }}>
            {/* Banner */}
            <Box
                sx={{
                    display: 'flex',
                    position: 'relative',
                    zIndex: 1,
                }}>
                <TalentBanner talentId={talent._id} bannerUrl={talent.profileBanner?.url} />
                <Box
                    sx={{
                        position: 'absolute',
                        bottom: 22,
                        left: 0,
                        zIndex: 2,
                    }}
                >

                <AvatarStatusFavorite
                    talentIds={talent._id}
                    size="xl"
                    image={talent.profilePicture?.url || ''}
                    currentStatus={talent.currentStatusUser || 'nothing'}
                    upercutFavorites={talent.upercutFavorites}
                    allowAvatarEdit
                      onStatusChange={(newStatus) => {
                    const backendStatus = newStatus === 'nothing' ? '' : newStatus;
                    updateStatus([talent._id], backendStatus);
                }}
                />
            </Box>
            </Box>
            <Grid container spacing="14px" alignItems="stretch">
                <Grid item xs={4} sx={{ display: 'flex' }}>
                    <Stack gap={2} width="100%">
                        {/* Profile */}
                        <TalentProfileCard talent={talent} />
                        {/* Complete Profile */}
                        <TalentProfileCompletionRate
                            value={talent?.profileCompletionRate ?? 0}
                            completedSections={talent?.completedProfileSections ?? []}
                        />
                        {/* Contacts */}
                        <TalentContactsCard talent={talent} onUpdated={refetch} />
                        {/* Salary */}
                        <TalentSalaryCard
                            talentId={talent._id}
                            talentName={`${talent.firstName} ${talent.lastName}`}
                            currentSalary={talent.currentSalary}
                            expectedSalary={talent.expectedSalary}
                        />
                        {/* Soft Skills */}
                        <TalentSoftSkillsForm talent={talent} />
                        {/* Preferences */}
                        <TalentPreferencesForm talent={talent} />

                    </Stack>
                </Grid>
                <Grid item xs={8}>
                    <Grid container spacing={2}>
                        {/* Bio */}
                        <Grid item xs={12}>
                            <TalentBioCard talent={talent} onUpdated={refetch} />
                        </Grid>

                        {/* Experience */}
                        <Grid item xs={12}>
                            <TalentExperienceList talent={talent} />
                        </Grid>

                        {/* Formation */}
                        <Grid item xs={6}>
                            <TalentEducationList talent={talent} />
                        </Grid>

                        {/* Certification */}
                        <Grid item xs={6}>
                            <TalentCertificatetList talent={talent} />
                        </Grid>
                        {/* Language */}
                        <Grid item xs={12}>
                            <LanguageForm talentLanguages={talent?.talentLanguages ?? []} />
                        </Grid>

                    </Grid>
                </Grid>
            </Grid>

        </Paper >
    );
};

export default TalentPreview;
